import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const LineItemActionsContext = createContext(null);

const LineItemActionsContextProvider = ({
  children,
  cancelActionEnabled,
  editDesignActionEnabled,
  reorderActionEnabled,
  editAndReorderActionEnabled,
  buyNowActionEnabled,
  viewSimilarItemsEnabled,
  designFeedbackActionEnabled,
  isReorderable,
  item,
  orderNumber,
  displayPosition,
  isGroupItem,
}) => {
  const lineItemActionsContextValues = useMemo(
    () => ({
      cancelActionEnabled,
      editDesignActionEnabled,
      reorderActionEnabled,
      editAndReorderActionEnabled,
      buyNowActionEnabled,
      viewSimilarItemsEnabled,
      designFeedbackActionEnabled,
      isReorderable,
      item,
      orderNumber,
      displayPosition,
      isGroupItem,
    }),
    [
      buyNowActionEnabled,
      cancelActionEnabled,
      editAndReorderActionEnabled,
      editDesignActionEnabled,
      isReorderable,
      item,
      orderNumber,
      reorderActionEnabled,
      viewSimilarItemsEnabled,
      designFeedbackActionEnabled,
      displayPosition,
      isGroupItem,
    ]
  );

  return (
    <LineItemActionsContext.Provider value={lineItemActionsContextValues}>
      {children}
    </LineItemActionsContext.Provider>
  );
};

LineItemActionsContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  cancelActionEnabled: PropTypes.bool,
  editDesignActionEnabled: PropTypes.bool,
  reorderActionEnabled: PropTypes.bool,
  editAndReorderActionEnabled: PropTypes.bool,
  buyNowActionEnabled: PropTypes.bool,
  isReorderable: PropTypes.bool,
  item: PropTypes.object,
  orderNumber: PropTypes.string,
  viewSimilarItemsEnabled: PropTypes.bool,
  designFeedbackActionEnabled: PropTypes.bool,
  displayPosition: PropTypes.number,
  isGroupItem: PropTypes.bool,
};

export { LineItemActionsContext, LineItemActionsContextProvider };
